import type { MarkdownSerializerState } from '@repo/secoda-editor/lib/markdown/serializer';
import ReactNode from '@repo/secoda-editor/nodes/ReactNode';
import type { SecodaEditorComponentProps } from '@repo/secoda-editor/types';
import type { ParseSpec } from 'prosemirror-markdown';
import type { NodeSpec, Node as ProsemirrorNode } from 'prosemirror-model';
import { ChartRenderer } from '../../../../AIAssistant/Messages/components/ChartRenderer';
import aiChart from '../rules/ai_chart';

export default class AiChart extends ReactNode {
	get name() {
		return 'ai_chart';
	}

	get schema(): NodeSpec {
		return {
			attrs: {
				chart_id: { default: null },
			},
			group: 'block',
			defining: true,
			atom: true,
			selectable: true,
			parseDOM: [
				{
					preserveWhitespace: 'full',
					tag: 'div.ai_chart',
				},
			],
			toDOM: (node) => [
				'div',
				{ class: 'ai_chart', id: node.attrs.chart_id },
				0,
			],
		};
	}

	toMarkdown(state: MarkdownSerializerState, node: ProsemirrorNode) {
		const { chart_id } = node.attrs;
		if (chart_id) {
			state.write(`\n\n<secoda-chart>${chart_id}</secoda-chart>\n\n`);
			state.closeBlock(node);
		}
	}

	parseMarkdown(): ParseSpec {
		return {
			block: 'ai_chart',
			getAttrs: (tok) => ({ chart_id: tok.attrs?.[0][1] }),
		};
	}

	component = ({ node }: SecodaEditorComponentProps) => (
		<ChartRenderer chartId={node.attrs.chart_id} />
	);

	get rulePlugins() {
		return [aiChart];
	}
}
